var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-center-wrap',[_c('div',{staticClass:"center-anchor-up"},[_vm._v("直播间设置")])])
}
var staticRenderFns = []

export { render, staticRenderFns }